<template>
  <tr>
    <!--<td>
            <v-checkbox
                    primary
                    hide-details
                    v-model="selected"
            ></v-checkbox>
        </td>-->
    <td @click="expand">{{ item.id }}</td>
    <td class="text-xs-right" @click="expand">{{ date }}</td>
    <td class="text-xs-right" @click="expand">{{ item.email }}</td>
    <td class="text-xs-right" @click="expand">{{ item.phone }}</td>
    <td class="text-xs-right" @click="expand">{{ item.price }}€</td>
    <td class="text-xs-right red--text">
      <v-menu offset-y>
        <v-btn
          small
          :color="item.status === 'Pagado' ? 'green' : 'red'"
          flat
          slot="activator"
        >
          {{ item.status }}
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile @click="setStatus('No paided')">
              <v-list-tile-title>Sin Pagar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="setStatus('Pagado')">
              <v-list-tile-title>Pagado</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </td>
    <td @click="(event) => event.preventDefault()" class="text-xs-right">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          v-if="item.recipe"
          @click="openRecipe"
          icon
          class="mx-0"
        >
          <v-icon color="green">insert_drive_file</v-icon>
        </v-btn>
        <span>Recibo</span>
      </v-tooltip>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-btn slot="activator" icon class="mx-0">
          <v-icon color="pink">delete</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline">Borrar reserva</v-card-title>
          <v-card-text
            >¿Estás seguro de que quieres eliminar la reserva? Esta acción es
            irreversible y eliminará también los datos de las personas de la
            reserva</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="deleteItem">Borrar</v-btn>
            <v-btn color="grey darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </td>
    <v-snackbar :timeout="600" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat color="orange" @click.native="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </tr>
</template>

<script>
export default {
  props: ["item", "selected"],
  name: "item-table",
  data() {
    return {
      menu: false,
      snackbar: null,
      text: "",
      dialog: false,
    };
  },
  computed: {
    date() {
      let t = new Date(this.item.date.seconds * 1000); // Epoch
      return t.toLocaleDateString();
    },
  },
  methods: {
    expand() {
      this.$emit("expand");
    },
    setStatus(text) {
      let status = this.item.status;
      this.item.status = text;
      let vue = this;

      //Si se usa this y se elimina una inscripcion se pasa a la siguiente y se envia correo a la siguiente
      //Recogemos antes el correo y asi no lo machacamos con el siguiente
      let emailSend = this.item.email;
      let idSend = this.item.id;

      this.$db
        .collection("forms")
        .doc("inscripciones")
        .collection("answers")
        .doc(this.item.id)
        .update({
          status: text,
        })
        .then(function () {
          vue.snackbar = true;
          vue.text = "Cambios guardados";
          if (text === "Pagado") {
            let send = vue.$firebase
              .functions()
              .httpsCallable("sendConfirmationEmail");
            send({ email: emailSend, id: idSend })
              .then(function (result) {
                console.log(result);
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        })
        .catch(function (error) {
          vue.item.status = status;
          vue.snackbar = true;
          vue.text = "ERROR: No se han guardado los cambios";
          console.error("Error writing document: ", error);
        });
    },
    openRecipe(e) {
      this.$storage
        .ref()
        .child(this.item.recipe)
        .getDownloadURL()
        .then(function (url) {
          window.open(url);
        })
        .catch(function (error) {
          // Handle any errors
        });
      console.log(this.item.recipe);
      e.preventDefault();
    },
    deleteItem() {
      this.dialog = false;

      const batch = this.$db.batch();
      const ref = this.$db.collection("forms").doc("inscripciones");
      const refForm = ref.collection("answers").doc(this.item.id);

      for (var i = 0; i < this.item.people.length; i++) {
        console.log(this.item.people[i].id);
        batch.delete(ref.collection("people").doc(this.item.people[i].id));
      }
      batch.delete(refForm);

      var vue = this;
      batch
        .commit()
        .then(function () {
          vue.snackbar = true;
          vue.text = `Eliminado ${vue.item.id}`;
        })
        .catch(function (error) {
          console.log(error);
          vue.snackbar = true;
          vue.text = `Error eliminando reserva`;
        });
    },
  },
};
</script>

<style scoped>
</style>